<div>
    <ui-page-title [inModal]="true" [pageCode]="pageCode" [showModalHeader]="true"
                   [title]="'' | translate"></ui-page-title>

    <div class="pb-6 pt-3">
        <div class="col-12">
            <div class="search-container">
                <p-accordion>
                    <p-accordionTab [header]="'searchCriteria' | translate" [selected]="true">
                        <personnel-picker-list-search-form
                            [showTopOrg]="showTopOrg"
                            [activeFieldDisable]="activeFieldDisable"
                            [form]="form"
                            (onSearch)="onSearch()"
                            [pageCode]="pageCode"
                            [isClear]="isClear"
                            [isIdentityNumberRequired]="isIdentityNumberRequired"
                            (onBack)="isClear = false"
                        ></personnel-picker-list-search-form>
                        <div class="grid">
                            <div class="col-10">
                                <ui-advance-search-footer-buttons (onClear)="onClear()" (onSearch)="onSearch()"
                                                                  [checkFormIsValid]="true" [form]="form"
                                                                  [idPrefix]="pageCode"></ui-advance-search-footer-buttons>
                            </div>
                            <div class="col-2 align-content-end">
                                <p-button label="{{'hrPerPersonnel.detailSearch.detailSearch' | translate}}" (onClick)="openDetailSearch()" badge="{{advancedSearchQueryModel?.length}}" styleClass="mr-2"></p-button>
                            </div>
                        </div>


                    </p-accordionTab>
                </p-accordion>
            </div>
        </div>
        <div class="col-12 mb-5" *ngIf="pageReady">
            <p-table
                *ngIf="advancedSearchQueryModel?.length===0"
                [id]="pageCode + 'list'"
                id="dataDictionaryTable"
                dataKey="compositeKey"
                styleClass="p-datatable-striped"
                [lazy]="true"
                (onLazyLoad)="lazyLoadData($event)"
                [value]="list"
                [loading]="loading"
                [(selection)]="selectedModel"
                [paginator]="true"
                [rows]="10"
                [rowsPerPageOptions]="rowsPerPageOptions"
                [totalRecords]="totalElements"
                [scrollable]="true"
                [selectionMode]="selectionMode"
                lazyLoadOnInit="false"
                (onRowSelect)="rowSelect($event)"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="{{'hrCommon.totalRecords' | translate}} {totalRecords} "
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th pFrozenColumn *ngIf="selectionMode && selectionMode == 'multiple'" style="width: 45px">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <ng-container *ngFor="let col of columns">
                            <th id="{{ col.field }}" pSortableColumn="{{ col.field }}" style="width: 200px"
                                *ngIf="checkCol(col.field)">
                                {{ col.header }}
                                <p-sortIcon field="{{ col.field }}"></p-sortIcon>
                            </th>
                        </ng-container>

                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-personnel>
                    <tr [pSelectableRow]="personnel">
                        <td pFrozenColumn *ngIf="selectionMode && selectionMode == 'multiple'" style="width: 45px">
                            <p-tableCheckbox [value]="personnel" [pSelectableRow]="personnel"></p-tableCheckbox>
                        </td>
                        <td style="width: 6rem"
                            *ngIf="checkCol('beginDate')">{{ personnel.beginDate | dateConvert }}</td>
                        <td style="width: 6rem" *ngIf="checkCol('endDate')">{{ personnel.endDate | dateConvert  }}</td>
                        <td style="width: 6rem" *ngIf="checkCol('registryNumber')">{{ personnel.registryNumber }}</td>
<!--                        <td style="width: 10rem"-->
<!--                            *ngIf="hasFullAuthority && checkCol('identificationNumber')">{{ personnel.identificationNumber }}</td>-->
                        <td style="width: 8rem" *ngIf="checkCol('name')">{{ personnel.name }}</td>
                        <td style="width: 8rem" *ngIf="checkCol('surname')">{{ personnel.surname }}</td>
                        <td style="width: 8rem"
                            *ngIf="checkCol('perPersonnelOrganization')">{{ personnel.perPersonnelOrganization }}</td>
                        <td style="width: 8rem"
                            *ngIf="checkCol('perPersonnelPosition')">{{ personnel.perPersonnelPosition }}</td>

                        <td style="width: 8rem" *ngIf="checkCol('perEmployeeType')">{{ personnel.perEmployeeType }}</td>
                        <td style="width: 10rem"
                            *ngIf="checkCol('perEmployeeSubtype')">{{ personnel.perEmployeeSubtype }}</td>
                        <td style="width: 8rem" *ngIf="checkCol('perWorkArea')">{{ personnel.perWorkArea }}</td>
                        <td style="width: 8rem" *ngIf="checkCol('perWorkSubarea')">{{ personnel.perWorkSubarea }}</td>
                        <td style="width: 8rem" *ngIf="checkCol('statusText')">{{ personnel.statusText  }}</td>
                        <td style="width: 8rem"
                            *ngIf="checkCol('startDate')">{{ personnel.startDate | dateConvert  }}</td>
                        <td style="width: 8rem"
                            *ngIf="checkCol('active')">{{ 'hrPerPersonnel.isActiveEmp.' + personnel.active | translate }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="15">{{ 'noRecordsFound' | translate }}</td>
                    </tr>
                </ng-template>
            </p-table>
            <p-table
                *ngIf="advancedSearchQueryModel?.length>0"
                [id]="pageCode + 'list'"
                id="personneListAdvancedSearch"
                dataKey="compositeKey"
                styleClass="p-datatable-striped"
                [lazy]="false"
                [value]="advancedSearchList"
                [loading]="loading"
                [(selection)]="selectedModel"
                [scrollable]="true"
                [selectionMode]="selectionMode"
                (onRowSelect)="rowSelect($event)"
                scrollHeight="500px"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th pFrozenColumn *ngIf="selectionMode && selectionMode == 'multiple'" style="width: 45px">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <ng-container *ngFor="let col of columns">
                            <th id="{{ col.field }}" pSortableColumn="{{ col.field }}" style="width: 200px"
                                *ngIf="checkCol(col.field)">
                                {{ col.header }}
                                <!--                                <p-sortIcon field="{{ col.field }}"></p-sortIcon>-->
                            </th>
                        </ng-container>

                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-personnel>
                    <tr [pSelectableRow]="personnel">
                        <td pFrozenColumn *ngIf="selectionMode && selectionMode == 'multiple'" style="width: 45px">
                            <p-tableCheckbox [value]="personnel" [pSelectableRow]="personnel"></p-tableCheckbox>
                        </td>
                        <td style="width: 6rem"
                            *ngIf="checkCol('beginDate')">{{ personnel.beginDate | dateConvert }}</td>
                        <td style="width: 6rem" *ngIf="checkCol('endDate')">{{ personnel.endDate | dateConvert  }}</td>
                        <td style="width: 6rem" *ngIf="checkCol('registryNumber')">{{ personnel.registryNumber }}</td>
<!--                        <td style="width: 10rem"-->
<!--                            *ngIf="hasFullAuthority && checkCol('identificationNumber')">{{ personnel.identificationNumber }}</td>-->
                        <td style="width: 8rem" *ngIf="checkCol('name')">{{ personnel.name }}</td>
                        <td style="width: 8rem" *ngIf="checkCol('surname')">{{ personnel.surname }}</td>
                        <td style="width: 8rem"
                            *ngIf="checkCol('perPersonnelOrganization')">{{ personnel.perPersonnelOrganization }}</td>
                        <td style="width: 8rem"
                            *ngIf="checkCol('perPersonnelPosition')">{{ personnel.perPersonnelPosition }}</td>

                        <td style="width: 8rem" *ngIf="checkCol('perEmployeeType')">{{ personnel.perEmployeeType }}</td>
                        <td style="width: 10rem"
                            *ngIf="checkCol('perEmployeeSubtype')">{{ personnel.perEmployeeSubtype }}</td>
                        <td style="width: 8rem" *ngIf="checkCol('perWorkArea')">{{ personnel.perWorkArea }}</td>
                        <td style="width: 8rem" *ngIf="checkCol('perWorkSubarea')">{{ personnel.perWorkSubarea }}</td>
                        <td style="width: 8rem" *ngIf="checkCol('statusText')">{{ personnel.statusText  }}</td>
                        <td style="width: 8rem"
                            *ngIf="checkCol('startDate')">{{ personnel.startDate | dateConvert  }}</td>
                        <td style="width: 8rem"
                            *ngIf="checkCol('active')">{{ 'hrPerPersonnel.isActiveEmp.' + personnel.active | translate }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="15">{{ 'noRecordsFound' | translate }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex align-items-center justify-content-between">
                        {{'hrCommon.totalRecords' | translate}} {{totalElements}}
                    </div>
                </ng-template>

            </p-table>
        </div>
    </div>

    <ui-sticky-buttonbar>
        <div class="mr-2">
            <button [id]="pageCode + '_cancel'" (click)="onCancel()" [label]="'button.cancel' | translate"
                    class="p-button-text" pButton></button>
        </div>
        <div>
            <button [id]="pageCode + '_select'" (click)="onRowSelectClickEvent()" [label]="addButtonLabel"
                    pButton></button>
        </div>
    </ui-sticky-buttonbar>
</div>
